export default "__VITE_ASSET__SkRQB$yE__"